var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isMantenance
    ? _c(
        "div",
        { attrs: { id: "change-barcode" } },
        [
          _c("p", [
            _vm._v(
              "ACROSS倉庫にある商品のバーコードラベルの貼り替え依頼を作成することができます"
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card", attrs: { id: "product-input" } }, [
            _c(
              "div",
              { staticClass: "mr-b-10" },
              [
                _c("fixed-header", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isShowFixedHeader,
                      expression: "isShowFixedHeader"
                    }
                  ],
                  attrs: {
                    textBtnAdd: "+ セット追加",
                    textBtnRegister: "依頼する"
                  },
                  on: {
                    handleClickAdd: function($event) {
                      _vm.openShippingProductAddModal = true
                    },
                    handleClickRegister: function($event) {
                      _vm.submit()
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: {
                      click: function($event) {
                        _vm.openShippingProductAddModal = true
                      }
                    }
                  },
                  [_vm._v("\n        + セット追加\n      ")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.sets.length > 0
              ? _c("table", { staticClass: "set-table" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    [
                      _vm._l(_vm.sets, function(set, index) {
                        return [
                          _c(
                            "tr",
                            {
                              key: "row-" + index,
                              staticClass: "row-data",
                              class: { "has-errors": set.errors.length }
                            },
                            [
                              _c("td", [
                                _c(
                                  "div",
                                  { staticClass: "flexbox-between gap-10" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "original-products" },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: set.originalProduct.image
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("div", [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "font-bold",
                                              attrs: {
                                                title:
                                                  set.originalProduct.itemName
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.sliceProductName(
                                                    set.originalProduct.itemName
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "flexbox" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "mr-r-10" },
                                                [
                                                  _c("b", [_vm._v("ASIN: ")]),
                                                  _vm._v(
                                                    _vm._s(
                                                      set.originalProduct.asin
                                                    ) + " "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _c("b", [_vm._v("SKU: ")]),
                                                _vm._v(
                                                  _vm._s(
                                                    set.originalProduct.sku
                                                  )
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "flexbox" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "mr-r-10" },
                                                [
                                                  _c("b", [_vm._v("商品ID: ")]),
                                                  _vm._v(
                                                    _vm._s(
                                                      set.originalProduct.itemId
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _c("b", [
                                                  _vm._v("商品ラベル: ")
                                                ]),
                                                _vm._v(
                                                  _vm._s(
                                                    set.originalProduct.fnsku
                                                  )
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("div", [
                                            _c("b", [_vm._v("ACROSS在庫数: ")]),
                                            _vm._v(
                                              _vm._s(
                                                set.originalProduct
                                                  .acrossQuantity
                                              ) + "個\n                    "
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "flexbox-between gap-10" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-warning",
                                            on: {
                                              click: function($event) {
                                                _vm.openOriginalProductsModal(
                                                  index
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    変更する\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("b", [_vm._v("▶")])
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                set.replacementProduct
                                  ? _c(
                                      "div",
                                      { staticClass: "replace-products" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "product-info" },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src:
                                                  set.replacementProduct.image
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("div", [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "font-bold",
                                                  attrs: {
                                                    title:
                                                      set.replacementProduct
                                                        .itemName
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.sliceProductName(
                                                        set.replacementProduct
                                                          .itemName
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {}, [
                                                _c("b", [_vm._v("ASIN: ")]),
                                                _vm._v(
                                                  _vm._s(
                                                    set.replacementProduct.asin
                                                  ) + "\n                    "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "flexbox gap-10"
                                                },
                                                [
                                                  _c("b", [
                                                    _vm._v("商品ラベル: ")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("div", [
                                                    Object.keys(
                                                      set.replacementProduct
                                                        .fnskus
                                                    ).length > 1
                                                      ? _c(
                                                          "select",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  set
                                                                    .replacementProduct
                                                                    .fnsku,
                                                                expression:
                                                                  "set.replacementProduct.fnsku"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "form-control",
                                                            class: {
                                                              "bg-no-input": !set
                                                                .replacementProduct
                                                                .fnsku
                                                            },
                                                            attrs: {
                                                              name: "fnsku-kbn",
                                                              id:
                                                                "fnsku-kbn-select-" +
                                                                set
                                                                  .replacementProduct
                                                                  .asin
                                                            },
                                                            on: {
                                                              change: [
                                                                function(
                                                                  $event
                                                                ) {
                                                                  var $$selectedVal = Array.prototype.filter
                                                                    .call(
                                                                      $event
                                                                        .target
                                                                        .options,
                                                                      function(
                                                                        o
                                                                      ) {
                                                                        return o.selected
                                                                      }
                                                                    )
                                                                    .map(
                                                                      function(
                                                                        o
                                                                      ) {
                                                                        var val =
                                                                          "_value" in
                                                                          o
                                                                            ? o._value
                                                                            : o.value
                                                                        return val
                                                                      }
                                                                    )
                                                                  _vm.$set(
                                                                    set.replacementProduct,
                                                                    "fnsku",
                                                                    $event
                                                                      .target
                                                                      .multiple
                                                                      ? $$selectedVal
                                                                      : $$selectedVal[0]
                                                                  )
                                                                },
                                                                function(
                                                                  $event
                                                                ) {
                                                                  _vm.changeFnsku(
                                                                    set.replacementProduct
                                                                  )
                                                                }
                                                              ]
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "option",
                                                              {
                                                                attrs: {
                                                                  value: ""
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "選択してください"
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _vm._l(
                                                              set
                                                                .replacementProduct
                                                                .fnskus,
                                                              function(
                                                                val,
                                                                key
                                                              ) {
                                                                return _c(
                                                                  "option",
                                                                  {
                                                                    key: key,
                                                                    domProps: {
                                                                      value: key
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        val
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      : _c("div", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                set
                                                                  .replacementProduct
                                                                  .fnsku
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("div", [
                                                    _c("b", [_vm._v("SKU:")]),
                                                    _vm._v(
                                                      _vm._s(
                                                        set.replacementProduct
                                                          .sku
                                                      ) +
                                                        "\n                      "
                                                    )
                                                  ])
                                                ]
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-warning",
                                            on: {
                                              click: function($event) {
                                                _vm.openReplacementProductsModal(
                                                  index
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  変更する\n                "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-primary",
                                        on: {
                                          click: function($event) {
                                            _vm.openReplacementProductsModal(
                                              index
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                商品を選択\n              "
                                        )
                                      ]
                                    )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center w-120" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.number",
                                      value: set.quantity,
                                      expression: "set.quantity",
                                      modifiers: { number: true }
                                    }
                                  ],
                                  staticClass: "form-control w-100",
                                  attrs: { type: "number", min: "1" },
                                  domProps: { value: set.quantity },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        set,
                                        "quantity",
                                        _vm._n($event.target.value)
                                      )
                                    },
                                    blur: function($event) {
                                      _vm.$forceUpdate()
                                    }
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-delete-selected-product",
                                    on: {
                                      click: function($event) {
                                        _vm.removeSet(index)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                削除\n              "
                                    )
                                  ]
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          set.errors.length
                            ? _c(
                                "tr",
                                {
                                  key: "errors" + index,
                                  staticClass: "row-errors"
                                },
                                [
                                  _c("td", { attrs: { colspan: "4" } }, [
                                    _c(
                                      "ul",
                                      { staticClass: "error-list" },
                                      _vm._l(set.errors, function(err, i) {
                                        return _c("li", { key: i }, [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(err) +
                                              "\n                "
                                          )
                                        ])
                                      }),
                                      0
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      })
                    ],
                    2
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "action-bar" }, [
              _vm.sets.length > 0
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: { click: _vm.submit }
                    },
                    [
                      _vm._v("\n        依頼する\n        "),
                      _c("i", {
                        staticClass: "fa fa-check fa-lg mr-l-5",
                        attrs: { "aria-hidden": "true" }
                      })
                    ]
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _vm.openShippingProductAddModal
            ? _c("shipping-product-add", {
                ref: "shippingMultiProductAddModal",
                attrs: {
                  defaultDescription:
                    "バーコード貼り替え依頼をする商品を選択してください",
                  columns: _vm.originalProductColumns,
                  selectedProducts: _vm.selectedShippingProducts
                },
                on: {
                  onHandleSearch: _vm.onHandleSearchShipping,
                  close: _vm.closeModalProductAdd,
                  handleSelectedProduct: _vm.handleAddSet,
                  handleSelectedProducts: _vm.handleAddSets
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.openDeliveryProductAddModal
            ? _c("delivery-product-add", {
                ref: "deliveryProductAddModal",
                attrs: {
                  defaultDescription:
                    "バーコード貼り替え依頼をする商品を選択してください",
                  columns: _vm.replacementProductColumns,
                  selectedProducts: _vm.selectedDeliveyProducts
                },
                on: {
                  onHandleSearch: _vm.onHandleSearchDelivery,
                  close: _vm.closeModalDeliveryProductAdd,
                  handleSelectedProduct: _vm.handleAddReplacementProduct
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.openConfirmModal
            ? _c("modal-confirm", {
                attrs: { message: _vm.confirmMessage },
                on: {
                  confirm: _vm.submitChangeBarcode,
                  close: _vm.closeModalConfirm
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.openAlertModal
            ? _c("modal-alert", {
                attrs: {
                  message: _vm.alertMessage,
                  customHide: true,
                  modalWidth: 550
                },
                on: { close: _vm.closeModalAlert }
              })
            : _vm._e()
        ],
        1
      )
    : _c("maintenance-modal", {
        attrs: {
          html: _vm.userInfo.acrossDeliveryStopExp,
          hasBypassMaintenance: true
        },
        on: {
          close: _vm.closeMaintenanceModal,
          bypassMaintenance: _vm.bypassMaintenance
        }
      })
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("変更元商品")]),
        _vm._v(" "),
        _c("th", [_vm._v("変更先商品")]),
        _vm._v(" "),
        _c("th", { staticClass: "w-120" }, [_vm._v("数量")]),
        _vm._v(" "),
        _c("th", { staticClass: "w-120" })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a35cf92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a35cf92","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/warehouseAcross/ChangeBarcode.vue
// module id = null
// module chunks = 